/* Gifts That Tell Stories — buyer review photos, production A carousel. */
(function () {
  'use strict';
  if (window.GttsBuyerPhotos) return;
  let nextId = 0;
  const locks = new Set();
  let previousOverflow = '';
  const mod = (value, length) => ((value % length) + length) % length;
  const clamp = (value, low, high) => Math.min(high, Math.max(low, value));
  function node(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }
  function button(className, label, symbol) {
    const element = node('button', className, symbol);
    element.type = 'button';
    element.setAttribute('aria-label', label);
    element.title = label;
    return element;
  }
  function cleanURL(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, document.baseURI);
      return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }
  function normalize(input) {
    if (!Array.isArray(input)) return [];
    return input.map(photo => {
      if (!photo || typeof photo !== 'object') return null;
      const src = cleanURL(photo.src);
      if (!src) return null;
      const rating = (typeof photo.rating === 'number' || (typeof photo.rating === 'string' && photo.rating.trim()))
        ? Number(photo.rating) : null;
      return {
        src,
        fullSrc: cleanURL(photo.fullSrc) || src,
        quote: typeof photo.quote === 'string' ? photo.quote.trim() : '',
        author: typeof photo.author === 'string' ? photo.author.trim() : '',
        rating: Number.isFinite(rating) && rating >= 0 && rating <= 5 ? rating : null,
        verified: photo.verified === true,
        reviewId: photo.reviewId == null ? '' : String(photo.reviewId)
      };
    }).filter(Boolean);
  }
  function stars(rating) {
    const element = node('span', 'bp-stars');
    element.setAttribute('role', 'img');
    element.setAttribute('aria-label', `${rating} out of 5 stars`);
    const empty = node('span', 'bp-stars-empty', '★★★★★');
    const filled = node('span', 'bp-stars-filled', '★★★★★');
    empty.setAttribute('aria-hidden', 'true');
    filled.setAttribute('aria-hidden', 'true');
    filled.style.width = `${rating / 5 * 100}%`;
    element.append(empty, filled);
    return element;
  }
  function mount(host, options = {}) {
    if (!(host instanceof Element)) throw new TypeError('GttsBuyerPhotos.mount requires an element.');
    const id = `gtts-bp-${++nextId}`;
    const abort = new AbortController();
    const listen = (target, event, handler, extra = {}) => target.addEventListener(event, handler, { ...extra, signal: abort.signal });
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let photos = [];
    let cards = [];
    let phase = 0;
    let active = -1;
    let width = 320;
    let cardWidth = 188;
    let stepWidth = 140;
    let autoWanted = !reducedMotion.matches;
    let visible = true;
    let hovered = false;
    let focused = false;
    let pointer = null;
    let ignoreClickUntil = 0;
    let timer = 0;
    let destroyed = false;
    let lightboxOpen = false;
    let lightboxIndex = 0;
    let returnFocus = null;
    const originalHidden = host.hidden;

    const root = node('section', 'bp gtts-buyer-photos');
    root.setAttribute('aria-labelledby', `${id}-title`);
    const header = node('div', 'bp-header');
    const heading = node('h3', 'bp-title', 'From Our Customers, With Love');
    heading.id = `${id}-title`;
    header.append(heading);
    const stage = node('div', 'bp-stage');
    stage.setAttribute('aria-roledescription', 'carousel');
    stage.setAttribute('aria-label', 'Customer review photos');
    const controls = node('div', 'bp-controls');
    const previous = button('bp-control bp-previous', 'Previous buyer photo', '←');
    const next = button('bp-control bp-next', 'Next buyer photo', '→');
    const count = node('span', 'bp-count');
    count.setAttribute('aria-live', 'off');
    const pause = button('bp-control bp-pause', 'Pause automatic slideshow', 'Ⅱ');
    controls.append(previous, count, next, pause);
    root.append(header, stage, controls);

    const dialog = node('dialog', 'bp-lightbox');
    dialog.setAttribute('aria-label', 'Customer review photo viewer');
    const lightboxTop = node('div', 'bp-lightbox-top');
    const lightboxCount = node('span', 'bp-lightbox-count');
    lightboxCount.setAttribute('aria-live', 'polite');
    const close = button('bp-lightbox-close', 'Close photo viewer', '×');
    lightboxTop.append(lightboxCount, close);
    const viewer = node('div', 'bp-lightbox-viewer');
    const lightboxPrevious = button('bp-lightbox-arrow bp-lightbox-previous', 'Previous photo', '←');
    const lightboxNext = button('bp-lightbox-arrow bp-lightbox-next', 'Next photo', '→');
    const fullImage = node('img', 'bp-lightbox-image');
    fullImage.decoding = 'async';
    fullImage.draggable = false;
    viewer.append(lightboxPrevious, fullImage, lightboxNext);
    const caption = node('div', 'bp-lightbox-caption');
    dialog.append(lightboxTop, viewer, caption);
    root.append(dialog);
    host.append(root);

    function alt(photo, index) {
      return photo.author ? `Customer review photo from ${photo.author}` : `Customer review photo ${index + 1}`;
    }
    function canAnimate() {
      return !destroyed && autoWanted && photos.length > 1 && visible && !document.hidden && !hovered && !focused && !pointer && !lightboxOpen;
    }
    function updatePlayback() {
      pause.textContent = autoWanted ? 'Ⅱ' : '▶';
      const label = autoWanted ? 'Pause automatic slideshow' : 'Play automatic slideshow';
      pause.setAttribute('aria-label', label);
      pause.title = label;
      pause.setAttribute('aria-pressed', String(!autoWanted));
      if (timer) clearTimeout(timer);
      timer = 0;
      if (canAnimate()) {
        timer = setTimeout(() => {
          timer = 0;
          if (canAnimate()) navigate(1);
        }, 3200);
      }
    }
    function distance(index) {
      if (photos.length < 2) return 0;
      return mod(index - phase + photos.length / 2, photos.length) - photos.length / 2;
    }
    function paint() {
      if (destroyed || !photos.length) return;
      const current = mod(Math.round(phase), photos.length);
      cards.forEach((card, index) => {
        const d = distance(index);
        const abs = Math.abs(d);
        const visibleCard = abs <= 2.3;
        const x = d * stepWidth;
        const y = Math.min(abs, 2) * 7;
        const rotationY = clamp(d, -1.7, 1.7) * -15;
        const scale = 1 - Math.min(abs, 2.4) * .145;
        const opacity = Math.max(0, 1 - abs * .30);
        if (!visibleCard) {
          if (card._bpVisible !== false) {
            card.style.opacity = '0';
            card.style.pointerEvents = 'none';
            card.tabIndex = -1;
            card.setAttribute('aria-hidden', 'true');
            card.dataset.active = 'false';
          }
          card._bpVisible = false;
          return;
        }
        card._bpVisible = true;
        if (!card._bpImage.getAttribute('src')) card._bpImage.src = photos[index].src;
        const wrapped = card._bpDistance !== undefined && Math.abs(d - card._bpDistance) > photos.length / 2;
        if (wrapped) {
          card.style.transition = 'none';
          requestAnimationFrame(() => { if (!destroyed) card.style.transition = ''; });
        }
        card._bpDistance = d;
        card.style.transform = `translate(-50%, -50%) translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0) rotateY(${rotationY.toFixed(2)}deg) scale(${scale.toFixed(4)})`;
        card.style.opacity = String(opacity);
        card.style.zIndex = String(50 - Math.round(abs * 10));
        card.style.pointerEvents = visibleCard && opacity > .1 ? 'auto' : 'none';
        if (card.dataset.active !== String(index === current)) {
          card.dataset.active = String(index === current);
          card.tabIndex = index === current ? 0 : -1;
          card.setAttribute('aria-hidden', String(index !== current));
        }
      });
      if (current !== active) {
        active = current;
        count.textContent = `${String(current + 1).padStart(2, '0')} / ${String(photos.length).padStart(2, '0')}`;
        count.setAttribute('aria-label', `Photo ${current + 1} of ${photos.length}`);
      }
    }
    function measure() {
      width = stage.clientWidth || host.clientWidth || 320;
      cardWidth = clamp(width * .61, 145, 214);
      stepWidth = cardWidth * .77;
      stage.style.setProperty('--bp-card-width', `${cardWidth}px`);
      paint();
    }
    function navigate(delta) {
      if (destroyed || photos.length < 2) return;
      phase = mod(Math.round(phase) + delta, photos.length);
      paint();
      updatePlayback();
    }
    function populateCaption(container, photo) {
      container.replaceChildren();
      if (photo.rating !== null) container.append(stars(photo.rating));
      if (photo.quote) container.append(node('p', 'bp-quote', photo.quote));
      if (photo.author || photo.verified) {
        const author = node('span', 'bp-author', photo.author);
        if (photo.verified) author.append(node('span', 'bp-verified', 'Verified buyer'));
        container.append(author);
      }
    }
    function showLightboxPhoto(index) {
      lightboxIndex = mod(index, photos.length);
      const photo = photos[lightboxIndex];
      fullImage.src = photo.fullSrc;
      fullImage.alt = alt(photo, lightboxIndex);
      lightboxCount.textContent = `${lightboxIndex + 1} / ${photos.length}`;
      populateCaption(caption, photo);
      caption.hidden = !caption.childElementCount;
      lightboxPrevious.hidden = lightboxNext.hidden = photos.length < 2;
    }
    function openLightbox(index) {
      if (destroyed || !photos.length || lightboxOpen || !root.isConnected) return;
      returnFocus = document.activeElement;
      lightboxOpen = true;
      phase = index;
      paint();
      showLightboxPhoto(index);
      if (!locks.size) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      locks.add(id);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      close.focus({ preventScroll: true });
      updatePlayback();
    }
    function closeLightbox(restore = true) {
      if (!lightboxOpen) return;
      lightboxOpen = false;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      locks.delete(id);
      if (!locks.size) document.body.style.overflow = previousOverflow;
      phase = lightboxIndex;
      paint();
      if (restore && returnFocus && returnFocus.isConnected) {
        const focusTarget = stage.contains(returnFocus) ? cards[active] : returnFocus;
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }
      updatePlayback();
    }
    function setPhotos(input) {
      if (destroyed) return;
      closeLightbox(false);
      if (pointer) endPointer({ pointerId: pointer.id }, true);
      focused = false;
      photos = normalize(input);
      phase = 0;
      active = -1;
      stage.replaceChildren();
      cards = photos.map((photo, index) => {
        const card = button('bp-card', `Open ${alt(photo, index).toLowerCase()} in full screen`, '');
        card.dataset.photoIndex = String(index);
        if (photo.reviewId) card.dataset.reviewId = photo.reviewId;
        const inner = node('span', 'bp-card-inner');
        const image = node('img', 'bp-image');
        image.alt = '';
        card._bpImage = image;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.draggable = false;
        image.width = 428;
        image.height = 428;
        inner.append(image);
        card.append(inner);
        stage.append(card);
        return card;
      });
      root.hidden = host.hidden = photos.length === 0;
      controls.hidden = photos.length < 2;
      measure();
      updatePlayback();
    }
    function endPointer(event, cancelled = false) {
      if (!pointer || event.pointerId !== pointer.id) return;
      const ending = pointer;
      pointer = null;
      root.classList.remove('bp-dragging');
      if (stage.hasPointerCapture && stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
      if (ending.dragging) {
        ignoreClickUntil = performance.now() + 450;
        const moved = phase - ending.phase;
        const change = Math.abs(moved) > .20 ? Math.sign(moved) * Math.max(1, Math.round(Math.abs(moved))) : 0;
        phase = mod(Math.round(ending.phase) + (cancelled ? 0 : change), photos.length);
        paint();
      }
      updatePlayback();
    }
    listen(previous, 'click', () => navigate(-1));
    listen(next, 'click', () => navigate(1));
    listen(pause, 'click', () => { autoWanted = !autoWanted; updatePlayback(); });
    listen(stage, 'click', event => {
      if (performance.now() < ignoreClickUntil) return;
      const card = event.target.closest('.bp-card');
      if (card && stage.contains(card)) openLightbox(Number(card.dataset.photoIndex));
    });
    listen(stage, 'keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        navigate(event.key === 'ArrowLeft' ? -1 : 1);
        if (cards[active]) cards[active].focus({ preventScroll: true });
      }
    });
    listen(stage, 'pointerdown', event => {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0) || photos.length < 2) return;
      focused = false;
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, phase, dragging: false };
      updatePlayback();
    });
    listen(stage, 'pointermove', event => {
      if (!pointer || pointer.id !== event.pointerId) return;
      const dx = event.clientX - pointer.x;
      const dy = event.clientY - pointer.y;
      if (!pointer.dragging && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
        endPointer(event, true);
        return;
      }
      if (!pointer.dragging && Math.abs(dx) > 7 && Math.abs(dx) > Math.abs(dy)) {
        pointer.dragging = true;
        root.classList.add('bp-dragging');
        stage.setPointerCapture(event.pointerId);
      }
      if (!pointer.dragging) return;
      event.preventDefault();
      phase = pointer.phase - dx / stepWidth;
      paint();
    }, { passive: false });
    listen(window, 'pointerup', event => endPointer(event));
    listen(window, 'pointercancel', event => endPointer(event, true));
    listen(stage, 'lostpointercapture', event => endPointer(event, true));
    listen(stage, 'dragstart', event => event.preventDefault());
    listen(stage, 'pointerenter', event => {
      if (event.pointerType !== 'mouse') return;
      hovered = true; updatePlayback();
    });
    listen(stage, 'pointerleave', event => {
      if (event.pointerType !== 'mouse') return;
      hovered = false; updatePlayback();
    });
    listen(root, 'focusin', event => {
      // Only a focused photo suspends playback; Play remains effective while its
      // control has focus. Opening the lightbox pauses through lightboxOpen.
      focused = stage.contains(event.target) && event.target.matches(':focus-visible'); updatePlayback();
    });
    listen(root, 'focusout', () => {
      queueMicrotask(() => {
        if (destroyed) return;
        focused = stage.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
        updatePlayback();
      });
    });
    listen(close, 'click', () => closeLightbox());
    listen(lightboxPrevious, 'click', () => showLightboxPhoto(lightboxIndex - 1));
    listen(lightboxNext, 'click', () => showLightboxPhoto(lightboxIndex + 1));
    listen(dialog, 'cancel', event => { event.preventDefault(); closeLightbox(); });
    listen(dialog, 'close', () => { if (lightboxOpen && !dialog.open) closeLightbox(); });
    listen(dialog, 'click', event => { if (event.target === dialog) closeLightbox(); });
    listen(dialog, 'keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); closeLightbox(); }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); showLightboxPhoto(lightboxIndex + (event.key === 'ArrowLeft' ? -1 : 1));
      }
      if (event.key === 'Tab') {
        const buttons = [close, lightboxPrevious, lightboxNext].filter(element => !element.hidden);
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    let viewerTouch = null;
    listen(viewer, 'pointerdown', event => { viewerTouch = { id: event.pointerId, x: event.clientX, y: event.clientY }; });
    listen(viewer, 'pointerup', event => {
      if (!viewerTouch || viewerTouch.id !== event.pointerId) return;
      const dx = event.clientX - viewerTouch.x, dy = event.clientY - viewerTouch.y;
      viewerTouch = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) showLightboxPhoto(lightboxIndex + (dx < 0 ? 1 : -1));
    });
    listen(viewer, 'pointercancel', () => { viewerTouch = null; });
    listen(document, 'visibilitychange', () => { updatePlayback(); });
    listen(reducedMotion, 'change', event => {
      if (event.matches) autoWanted = false;
      updatePlayback();
    });
    const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      updatePlayback();
    }, { threshold: .08 }) : null;
    if (observer) observer.observe(root);
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    if (resize) resize.observe(stage);
    else listen(window, 'resize', measure);
    setPhotos(options.photos || []);
    return {
      setPhotos,
      destroy() {
        if (destroyed) return;
        destroyed = true;
        closeLightbox(false);
        if (timer) clearTimeout(timer);
        abort.abort();
        if (observer) observer.disconnect();
        if (resize) resize.disconnect();
        root.remove();
        host.hidden = originalHidden;
      }
    };
  }
  window.GttsBuyerPhotos = Object.freeze({ mount });
})();


/*
 * Reads customer photos already rendered by the current product's Judge.me widget.
 * No network requests, API credentials, filter changes, or storefront mutations.
 * Keep the receiving component hidden until onPhotos receives a non-empty array.
 */
(function (global) {
  'use strict';

  const WIDGET_SELECTOR = '#judgeme_product_reviews[data-product-id]';
  const REVIEW_SELECTOR = '.jm-review-item[review-uuid], .jdgm-rev';
  const PHOTO_SELECTOR = '.jm-media-thumbnail-list__thumbnail img, .jdgm-rev__pic-img';
  const MAX_PHOTOS = 30;

  function text(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function imageURL(value) {
    if (!value) return null;
    try {
      const url = new URL(value, global.location.href);
      // This is the review-image host verified on this storefront. Do not take
      // product thumbnails, reviewer avatars, video posters, or arbitrary URLs.
      if (url.protocol !== 'https:' || url.hostname !== 'review-images.judgeme.com') return null;
      return url.href;
    } catch (_) {
      return null;
    }
  }

  function photoFromImage(img) {
    const source = imageURL(img.getAttribute('src')) || imageURL(img.getAttribute('data-src'));
    if (!source) return null;
    const candidates = [{ url: source, width: 0 }];
    const srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    srcset.split(',').forEach(function (part) {
      const match = part.trim().match(/^(\S+)\s+(\d+(?:\.\d+)?)w$/);
      const url = match && imageURL(match[1]);
      if (url) candidates.push({ url: url, width: Number(match[2]) });
    });
    candidates.sort(function (a, b) { return a.width - b.width; });
    const best = candidates[candidates.length - 1].url;
    const link = img.closest('a[href]');
    const fullSrc = (link && imageURL(link.getAttribute('href'))) || best;
    const key = new URL(source);
    key.search = '';
    key.hash = '';
    return { key: key.href, src: best, fullSrc: fullSrc };
  }

  function ratingFromReview(review) {
    const current = review.querySelector('.jm-star-rating[aria-label]');
    const match = current && current.getAttribute('aria-label').match(/^([0-5](?:\.\d+)?)\s+out of 5 stars?$/i);
    const legacy = review.querySelector('.jdgm-rev__rating[data-score]');
    const raw = match ? match[1] : legacy && legacy.getAttribute('data-score');
    const rating = raw === null || raw === '' ? NaN : Number(raw);
    return Number.isFinite(rating) && rating >= 1 && rating <= 5 ? rating : null;
  }

  function isProductWidget(widget, productId) {
    return widget.getAttribute('data-product-id') === productId &&
      widget.getAttribute('data-shop-reviews') === 'false';
  }

  function reviewMatchesProduct(review, productId) {
    const explicitProductId = review.getAttribute('data-product-id');
    if (explicitProductId && explicitProductId !== productId) return false;
    if (review.closest('[data-shop-reviews="true"], [data-review-type="shop"], [data-review-type="store"]')) return false;

    const current = new URL(global.location.href);
    const currentProduct = current.pathname.match(/\/products\/([^/]+)/);
    // Grouped reviews can link to the product they actually belong to. Treat
    // an external store or another product handle as an explicit mismatch.
    return Array.from(review.querySelectorAll('a[href]')).every(function (link) {
      let url;
      try { url = new URL(link.getAttribute('href'), current); } catch (_) { return true; }
      const linkedProduct = url.pathname.match(/\/products\/([^/]+)/);
      if (!linkedProduct) return true;
      if (url.origin !== current.origin) return false;
      return !!currentProduct && linkedProduct[1] === currentProduct[1];
    });
  }

  function collect(widget, productId, includeGallery) {
    const photos = new Map();
    const rejectedKeys = new Set();
    const galleryKeys = new Set();
    let productMismatch = false;

    widget.querySelectorAll(REVIEW_SELECTOR).forEach(function (review) {
      if (review.closest(WIDGET_SELECTOR) !== widget) return;
      if (!reviewMatchesProduct(review, productId)) {
        productMismatch = true;
        review.querySelectorAll(PHOTO_SELECTOR).forEach(function (img) {
          const photo = photoFromImage(img);
          if (photo) rejectedKeys.add(photo.key);
        });
        return;
      }
      const metadata = {
        quote: text(review.querySelector('.jm-review-content__body, .jdgm-rev__body')),
        rating: ratingFromReview(review),
        author: text(review.querySelector('.jm-reviewer-info__name, .jdgm-rev__author')),
        // The observed widget does not expose purchase verification. Unknown
        // status must remain false; callers must not invent a verified badge.
        verified: false,
        reviewId: review.getAttribute('review-uuid') || review.getAttribute('data-id') || ''
      };
      review.querySelectorAll(PHOTO_SELECTOR).forEach(function (img) {
        const photo = photoFromImage(img);
        if (!photo || photos.has(photo.key) || photos.size >= MAX_PHOTOS) return;
        photos.set(photo.key, Object.assign({ src: photo.src, fullSrc: photo.fullSrc }, metadata));
      });
    });
    // The opt-in applies only inside this matched product widget. Gallery-only
    // photos rely on its product-group/fallback settings and have no metadata.
    if (includeGallery && !productMismatch) {
      widget.querySelectorAll('.jm-media-grid img').forEach(function (img) {
        if (img.closest(WIDGET_SELECTOR) !== widget) return;
        const photo = photoFromImage(img);
        if (!photo || photos.has(photo.key) || photos.size >= MAX_PHOTOS) return;
        galleryKeys.add(photo.key);
        photos.set(photo.key, {
          src: photo.src, fullSrc: photo.fullSrc,
          quote: '', rating: null, author: '', verified: false, reviewId: ''
        });
      });
    }
    return { photos: photos, rejectedKeys: rejectedKeys, galleryKeys: galleryKeys, productMismatch: productMismatch };
  }

  function connect(options) {
    const productId = String(options.productId || '');
    const root = options.root || global.document;
    const onPhotos = options.onPhotos;
    const includeGallery = options.includeGallery === true;
    if (!/^\d+$/.test(productId) || typeof onPhotos !== 'function') {
      throw new TypeError('BuyerPhotoSource.connect requires a numeric productId and onPhotos callback.');
    }
    let observer = null;
    let discoveryTimer = null;
    let stopped = false;
    let pending = false;
    let lastSignature = null;
    let widget = null;
    let galleryBlocked = false;
    const cache = new Map();
    const startingProduct = new URL(global.location.href).pathname.match(/\/products\/([^/]+)/);

    function emit() {
      if (stopped) return;
      const photos = Array.from(cache.values(), function (entry) { return entry.photo; });
      const signature = JSON.stringify(photos);
      if (signature === lastSignature) return;
      lastSignature = signature;
      onPhotos(photos);
    }

    function schedule() {
      if (stopped || pending) return;
      pending = true;
      Promise.resolve().then(function () {
        pending = false;
        if (!stopped) reconcile(true);
      });
    }

    function reconcile(readChanges) {
      if (stopped) return;
      const currentProduct = new URL(global.location.href).pathname.match(/\/products\/([^/]+)/);
      if ((startingProduct && (!currentProduct || currentProduct[1] !== startingProduct[1])) ||
          (root.nodeType !== 9 && root.isConnected === false)) {
        cache.clear();
        emit();
        disconnect();
        return;
      }
      const candidates = root.matches && root.matches(WIDGET_SELECTOR) ? [root] : root.querySelectorAll(WIDGET_SELECTOR);
      const next = Array.from(candidates).find(function (candidate) { return isProductWidget(candidate, productId); }) || null;
      if (!next && ((widget && widget.isConnected && !isProductWidget(widget, productId)) || candidates.length)) {
        cache.clear();
      }
      const replaced = next !== widget;
      if (replaced) {
        if (observer) observer.disconnect();
        observer = null;
        widget = next;
        if (widget) {
          observer = new MutationObserver(schedule);
          observer.observe(widget, {
            subtree: true, childList: true, characterData: true, attributes: true,
            attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset', 'href', 'aria-label', 'data-score', 'data-product-id', 'data-shop-reviews', 'data-review-type', 'review-uuid', 'data-id']
          });
        }
      }
      if (widget && (readChanges || replaced)) {
        const result = collect(widget, productId, includeGallery && !galleryBlocked);
        result.rejectedKeys.forEach(function (key) { cache.delete(key); });
        if (result.productMismatch) {
          galleryBlocked = true;
          cache.forEach(function (entry, key) { if (entry.fromGallery) cache.delete(key); });
        }
        result.photos.forEach(function (photo, key) {
          const fromGallery = result.galleryKeys.has(key);
          const previous = cache.get(key);
          if (previous && !previous.fromGallery && fromGallery) return;
          if (!result.rejectedKeys.has(key) && (previous || cache.size < MAX_PHOTOS)) {
            cache.set(key, { photo: photo, fromGallery: fromGallery });
          }
        });
      }
      emit();
    }

    function disconnect() {
      stopped = true;
      if (observer) observer.disconnect();
      if (discoveryTimer !== null) global.clearInterval(discoveryTimer);
    }

    reconcile(true);
    // A cheap identity check detects late insertion or whole-widget replacement.
    // Only the matched widget has a MutationObserver; no whole-document observer
    // or network polling is used. The component owns this connection's lifetime.
    if (!stopped) discoveryTimer = global.setInterval(function () { reconcile(false); }, 1000);
    return disconnect;
  }

  global.BuyerPhotoSource = { connect: connect };
})(window);


(function () {
  'use strict';
  if (customElements.get('gtts-buyer-photo-gallery')) return;

  class BuyerPhotoGallery extends HTMLElement {
    static get observedAttributes() { return ['data-product-id']; }

    connectedCallback() {
      if (this.gallery) return;
      this.hidden = true;
      const productId = this.dataset.productId;
      if (!/^\d+$/.test(productId || '')) return;
      this.gallery = window.GttsBuyerPhotos.mount(this, { photos: [] });
      this.disconnectSource = window.BuyerPhotoSource.connect({
        productId: productId,
        root: document,
        includeGallery: true,
        onPhotos: photos => {
          if (this.isConnected && this.gallery) this.gallery.setPhotos(photos);
        }
      });
    }

    disconnectedCallback() {
      if (this.disconnectSource) this.disconnectSource();
      if (this.gallery) this.gallery.destroy();
      this.disconnectSource = null;
      this.gallery = null;
      this.hidden = true;
    }

    attributeChangedCallback(name, previous, value) {
      if (previous === value || !this.isConnected || !this.gallery) return;
      this.disconnectedCallback();
      this.connectedCallback();
    }
  }

  customElements.define('gtts-buyer-photo-gallery', BuyerPhotoGallery);
})();
